import { z } from "zod";
import { addressResponseSchema } from "@common/schemas/entity.schema";
import { userResponseSchema } from "@common/schemas/user.schema";
import { EntityIndustry, EntityProfileType } from "@common/types/entity";
import { OrganizationEntitySchema } from "@common/types/organizationEntity";
import { utcDatetime } from "@common/helpers/date";
import { entityProfileResponseSchema } from "./entity-profile-response.schema";

const entityAddressResponseSchema = addressResponseSchema
    .unwrap()
    .omit({ id: true, entityId: true });

const taxLocationResponseSchema = z.object({
    location: z.string(),
    start: z.string().date().nullable(),
    end: z.string().date().nullable(),
});

export const entityResponseSchema = z.object({
    id: z.number(),
    uuid: z.string().uuid(),
    name: z.string().nullable(),
    workspaceId: z.string().uuid(),
    userId: z.number().nullable(),
    user: userResponseSchema.nullable(),
    address: entityAddressResponseSchema.nullable().default(null),
    taxLocations: z.array(taxLocationResponseSchema),
    organizationAssignments: z.array(OrganizationEntitySchema),
    bookkeepingYears: z.array(z.number()),
    bookkeepingStartDate: z.string().date(),
    // Deprecated column that is never selected; kept for the Entity type.
    onboardingComplete: z.boolean().default(false),
    industry: z.nativeEnum(EntityIndustry),
    legalType: z.nativeEnum(EntityProfileType).nullable(),
    profile: entityProfileResponseSchema,
    iconColor: z.string(),
    logo: z.string().nullable(),
    isBusiness: z.boolean(),
    isPersonal: z.boolean(),
    isMockEntity: z.boolean(),
    openingBalanceSubmitted: z.boolean(),
    reportsReady: z.boolean(),
    transactionEnrichmentPausedAt: utcDatetime.nullable(),
    federalTaxRate: z.number(),
    allowAITrainingOnTheirData: z.boolean(),
    hasCustomChartOfAccounts: z.boolean(),
});

export const entityWithUnloadedRelationsResponseSchema =
    entityResponseSchema.extend({
        user: userResponseSchema.nullable().default(null),
        taxLocations: entityResponseSchema.shape.taxLocations.default([]),
        organizationAssignments: z.array(OrganizationEntitySchema).optional(),
    });
